// HTTP errors
export const HttpNotFoundError = createError('HttpNotFoundError', '404 Not Found');
export const HttpNotAuthorizedError = createError('HttpNotAuthorizedError', '401 Not Authorized');
export const HttpForbiddenError = createError('HttpForbiddenError', '403 Forbidden');
export const HttpServerError = createError('HttpApiError', '500 Internal Server Error');

// Auth Errors
export const NotAuthorizedError = createError('NotAuthorizedError', 'Not Authorized');
export const ForbiddenError = createError('ForbiddenError', 'Forbidden');

// es6-error is a module that does errors but the stack trace does not work properly
function createError(name, defaultMessage) {
  const customError = function (message) {
    this.name = name;
    this.message = message || defaultMessage;
    this.stack = (new Error(message || defaultMessage)).stack;
    // looks like uncommenting the following shows the proper error but wrong stack instead
    // if (Error.captureStackTrace) {
    //   // for v8 this is preferable:
    //   Error.captureStackTrace(this, customError);
    // }
  };
  customError.prototype = Object.create(Error.prototype);
  customError.prototype.constructor = customError;

  return customError;
}



// WEBPACK FOOTER //
// ./src/app/errors.js